module.exports = __webpack_public_path__ + "static/sf_14.0cf04960.png";